import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { OptInModel } from 'app/models/opt-in.model';
import { OptInService } from 'app/services/opt-in.service';

@Injectable()
export class OptInResolver  {

    constructor(private service: OptInService)
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<OptInModel> {
        return this.service.GetOptIn(route.params.user_in_group_id, route.params.opt_in_token);
    }
}
